import Papa from 'papaparse';

const CLIENTS = {
  'us': '457828492',
  'stg': '1625199249',
}
export default async function fetchDataFromSpreadsheet(client) {
  const gid = CLIENTS[client] || CLIENTS['us'];
  const url =
    `https://docs.google.com/spreadsheets/d/e/2PACX-1vRiw274r-fvxtn3-FnjNv7vrc271B-FceTOWWGLsvoYQIDLTfQk7wq4hKL1RtLhIXoSUBWmfqdHwa9Q/pub?gid=${gid}&single=true&output=csv`;
  return await fetchCsvAsJson(url);
}

async function fetchCsvAsJson(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Network response was not ok');
  const csvText = await response.text();

  // Wrap Papa.parse in a Promise so we can await it
  return await new Promise((resolve, reject) => {
    Papa.parse(csvText, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => resolve(results.data),
      error: reject,
    });
  });
}
